import { toast } from 'react-toastify';

export const showToast = ({ toastId = null, type = 'info', message }) => {
  if (toastId) toast.dismiss(toastId);
  toast[type](message);
};
